module.exports = __webpack_public_path__ + "static/img/vip-header-3.9c3be9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/vip-header-3.png
// module id = oJFI
// module chunks = 1